export default "__VITE_ASSET__DAtMa50G__"